module.exports = __webpack_public_path__ + "img/bbjw2.17829d98.jpg";